var _circle, _path;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCredit = function SvgCredit(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#4E9700",
    opacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4E9700",
    d: "M13.038 15.136l-2.55-1.413c-.156-.087-.352-.03-.439.126-.031.057-.045.121-.039.186l.793 8.57c.017.178.174.308.352.292.04-.004.08-.015.115-.033l7.688-3.87c.16-.08.224-.274.143-.433-.03-.058-.075-.106-.131-.137l-2.536-1.406c1.967-3.113 6.89-4.27 7.667-3.88l.017.009c.156.083.35.026.435-.129.086-.156.03-.352-.126-.439l-.014-.008c-3.162-1.679-8.785-1.683-11.375 2.565z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCredit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/credit.39711eb1.svg";
export { ForwardRef as ReactComponent };